import { IconButton, Tooltip } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

export default function SearchButton({ ...props }) {
  return (
    <Tooltip title="Search">
      <IconButton {...props}>
        <SearchIcon sx={{ color: "black" }} size="small" ></SearchIcon>
      </IconButton>
    </Tooltip>
  );
}
